import { ErrorIcon, Row, SuccessIcon, Typography, WarningIcon } from "@commonlibs";
import { CalloutRoot } from "./Callout.styles";
import { spacing } from "ui/config/theme/spacing/spacing";
import { CalloutProps, CalloutStatus } from "./Callout.types";
import { JSXElementConstructor, SVGProps } from "react";
import clsx from "clsx";

const CALLOUT_ICONS: Record<CalloutStatus, JSXElementConstructor<Omit<SVGProps<SVGSVGElement>, "children">>> = {
    success: SuccessIcon,
    warning: WarningIcon,
    error: ErrorIcon,
};

export default function Callout({ text, status, className, style, icon = true }: CalloutProps) {
    const Icon = CALLOUT_ICONS[status];

    return (
        <CalloutRoot className={clsx("callout", status, className)} style={style}>
            <Row alignItems="center" gap={spacing[2]}>
                {icon && <Icon />}
                <Typography variant="body3Strong">{text}</Typography>
            </Row>
        </CalloutRoot>
    );
}
